import React from 'react';
import { useNewCheckIncompleteGsapQuery } from './NewGsapQuizSlice';
import Loading from 'components/global/layout/Loading';
import GetGsapAptitudeQuestion from './GetGsapAptitudeQuestion';

import StartGsapTestScreen from './StartGsapTestScreen';

const CheckQuizStatus = () => {
  // changed this: useNewCheckIncompleteAptitudeQuery , according to new aptitude slice
  const { isLoading, isSuccess, data } = useNewCheckIncompleteGsapQuery();
  const condition = isSuccess && Boolean(data.responses);

  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : condition ? (
        <StartGsapTestScreen data={data} />
      ) : (
        <GetGsapAptitudeQuestion />
      )}
    </div>
  );
};

export default CheckQuizStatus;
